export default "https://cdn-static-staging.gokick.com/assets/ec0de4ab37568b9a2e84c5fbf7dadc9a5c7c6fae/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";